import { useState } from "react";

import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import UsuarioField from "../../components/fields/UsuarioField";
import Container from "../../components/Generics/Container";
import { Usuario } from "../../model/entities/Usuario";
import TextFieldGeneric from "../../components/Generics/TextFieldGeneric";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import PerfilField from "../../components/fields/PerfilField";
import { SaveOutlined } from "@mui/icons-material";
import usuarioApi from "../../api/usuarioApi";
import { Plus } from "@phosphor-icons/react";
import { useSnack } from "../../redux/snack/snackHooks";
import ButtonGeneric from "../../components/Generics/ButtonGeneric";
import ModalGeneric from "../../components/Generics/ModalGeneric";

type Props = {};

const UsuariosPage: React.FC<Props> = (props) => {
  const [usuarioSelecionado, setUsuarioSelecionado] = useState<Usuario | null>(
    null
  );
  const [verSenha, setVerSenha] = useState(false);
  const [openModalAlterarSenha, setOpenModalAlterarSenha] = useState(false);
  const [novaSenha, setNovaSenha] = useState("");
  const mostrarSnack = useSnack();

  const salvar = async () => {
    try {
      if (!usuarioSelecionado?.senha && usuarioSelecionado?.senha === "") {
        mostrarSnack("Informa a senha do usuário!", "error");
        return;
      }

      if (!usuarioSelecionado?.perfil) {
        mostrarSnack("Informe o perfil do usuário!", "error");
        return;
      }

      if (!usuarioSelecionado?.nome || usuarioSelecionado.nome === "") {
        mostrarSnack("Informe o nome do usuário!", "error");
        return;
      }

      if (!usuarioSelecionado?.login || usuarioSelecionado.login === "") {
        mostrarSnack("Informe o login do usuário!", "error");
        return;
      }

      if (!usuarioSelecionado?.senha || usuarioSelecionado.senha === "") {
        mostrarSnack("Informe a senha do usuário!", "error");
        return;
      }

      if (!usuarioSelecionado) return;

      if (!usuarioSelecionado.id) {
        await usuarioApi.insert({
          login: usuarioSelecionado.login,
          nome: usuarioSelecionado.nome,
          perfilId: usuarioSelecionado.perfil.id,
          senha: usuarioSelecionado.senha,
          email: usuarioSelecionado.email,
        });
        mostrarSnack(
          `Novo usuário ${usuarioSelecionado.nome} cadastrado.`,
          "success"
        );
        setUsuarioSelecionado(null);
        window.location.reload();
        return;
      }

      await usuarioApi.update(usuarioSelecionado.id, {
        nome: usuarioSelecionado.nome,
        senha: usuarioSelecionado.senha,
        perfilId: usuarioSelecionado.perfil.id,
        email: usuarioSelecionado.email,
      });

      setUsuarioSelecionado(null);
      window.location.reload();
    } catch (erro: any) {
      console.log(erro);
      if (erro.data === "Já existe um usuário com este login") {
        mostrarSnack("Já existe um usuário com este login", "error");
      }
      mostrarSnack(
        `Errro ao atualizar informações do usuário ${usuarioSelecionado?.nome}`,
        "error"
      );
    }
  };

  const atualizarSenha = async () => {
    try {
      if (!usuarioSelecionado) return;
      if (!novaSenha || novaSenha === "") {
        mostrarSnack("Informa a nova senha do usuário!", "error");
        return;
      }

      await usuarioApi.atualizarSenha(usuarioSelecionado.id, novaSenha);
      mostrarSnack(
        `Senha do usuário ${usuarioSelecionado.nome} atualizada.`,
        "success"
      );
      setOpenModalAlterarSenha(false);
    } catch (erro: any) {
      mostrarSnack(
        `Errro ao atualizar senha do usuário ${usuarioSelecionado?.nome}`,
        "error"
      );
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container page>
        <Grid item xs={12} md={6}></Grid>
        <Grid container spacing={2}>
          {(!usuarioSelecionado || !usuarioSelecionado.id) && (
            <Grid item xs={12} style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                children={"Novo usuário"}
                startIcon={<Plus />}
                onClick={() => setUsuarioSelecionado({ ...new Usuario() })}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <UsuarioField
              usuario={usuarioSelecionado}
              setUsuario={(user) => {
                setUsuarioSelecionado(user);
              }}
              idUsuario={usuarioSelecionado?.id}
            />
          </Grid>

          {usuarioSelecionado && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <h2>Configurações do usuário {usuarioSelecionado.nome}</h2>
              </Grid>

              <Grid item xs={12} md={6}>
                <TextFieldGeneric
                  label="Login"
                  disabled={Boolean(usuarioSelecionado.id)}
                  value={usuarioSelecionado.login}
                  onChange={(value) => {
                    setUsuarioSelecionado({
                      ...usuarioSelecionado,
                      login: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextFieldGeneric
                  label="Nome"
                  value={usuarioSelecionado.nome}
                  onChange={(value) => {
                    setUsuarioSelecionado({
                      ...usuarioSelecionado,
                      nome: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  style={{ width: "100%" }}
                  label="Senha"
                  disabled={Boolean(usuarioSelecionado.id)}
                  value={usuarioSelecionado.senha}
                  onChange={(value) => {
                    setUsuarioSelecionado({
                      ...usuarioSelecionado,
                      senha: value.target.value,
                    });
                  }}
                  type={verSenha ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setVerSenha(!verSenha)}
                        >
                          {verSenha ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {usuarioSelecionado.id && (
                  <span
                    style={{
                      fontSize: "12px",
                      textAlign: "right",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    A senha é criptografada. Para alterar. Solicite uma nova
                    senha na tela de login.
                  </span>
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <TextFieldGeneric
                  label="E-mail"
                  value={usuarioSelecionado.email}
                  onChange={(value) => {
                    setUsuarioSelecionado({
                      ...usuarioSelecionado,
                      email: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <PerfilField
                  perfil={usuarioSelecionado?.perfil ?? null}
                  idPerfil={usuarioSelecionado?.perfil?.id ?? 0}
                  setPerfil={(value) => {
                    if (value) {
                      setUsuarioSelecionado({
                        ...usuarioSelecionado,
                        perfil: value,
                      });
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <ButtonGeneric
                  label={"Alterar senha"}
                  onClick={() => {
                    setOpenModalAlterarSenha(true);
                  }}
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} style={{ textAlign: "center" }}>
                <Button
                  children={"Salvar"}
                  onClick={() => salvar()}
                  variant="contained"
                  startIcon={<SaveOutlined />}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        {openModalAlterarSenha && (
          <ModalGeneric
            open={openModalAlterarSenha}
            onClose={() => setOpenModalAlterarSenha(false)}
          >
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextFieldGeneric
                    label={"Digite a nova senha"}
                    value={novaSenha}
                    onChange={(value) => setNovaSenha(value)}
                  />
                </Grid>

                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <ButtonGeneric
                    label={"Atualizar senha"}
                    onClick={atualizarSenha}
                  />
                </Grid>
              </Grid>
            </Container>
          </ModalGeneric>
        )}
      </Container>
    </div>
  );
};

export default UsuariosPage;
